<template>
    <div>
        <div class="groups-title">{{ $t('permission_configuration_management.group.groupManagement') }}</div>
        <div class="groups-top">
            <group-search></group-search>
        </div>
        <table-groups></table-groups>
    </div>
</template>

<script>
    import GroupSearch from '../group/GroupSearch'
    import TableGroups from '../group/TableGroups'

    export default {
        name: 'groups',
        components: {
            GroupSearch,
            TableGroups
        }
    }
</script>

<style scoped>
    .groups-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .groups-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/group/Groups.vue